import {CourseSearchStudent} from './course-search-parameters';

export class CourseSearchUpdateRequest {
  courseId: string;
  students: CourseSearchStudent[];
}
